import { useState, useRef, useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { FiChevronDown, FiChevronLeft } from 'react-icons/fi';
import useStyles from './index.styles';
import useClickOutside from 'hooks/useClickOutside';

interface SenderSearchProps {
  onSearch: (x: string, y: string) => void;
  label: string;
  senderName: string;
  senderValue: string;
  senderModuleName: string;
  senderModuleValue: string;
}

interface FilterOptionType {
  label: string;
  placeholder: string;
  name: string;
}

const filterOptions: FilterOptionType[] = [
  { label: 'campaign', name: 'campaign', placeholder: 'Campaign Name' },
  { label: 'workflow', name: 'workflow', placeholder: 'Workflow Name' },
];

const SenderSearch: React.FC<SenderSearchProps> = ({
  label,
  senderName,
  senderValue,
  senderModuleName,
  senderModuleValue,
  onSearch,
}) => {
  const classes = useStyles();
  const filterRef = useRef<HTMLDivElement>(null);

  const [showOptions, setShowOptions] = useState<boolean>(false);

  const handleOptions = () => setShowOptions(!showOptions);

  useClickOutside(filterRef, () => showOptions && setShowOptions(false));

  const selectedOption = useMemo(() => {
    const option = filterOptions.find(
      (option) => option.name === senderModuleValue
    );
    if (option) return option;
    return null;
  }, [senderModuleValue]);

  return (
    <Box>
      <Typography align='center'>{label}</Typography>

      <Box sx={{ position: 'relative' }}>
        <Box className={classes.workflowSearchbarCont}>
          <Typography
            className={classes.workflowSearchbarLabel}
            onClick={handleOptions}
          >
            {`${selectedOption?.label}:`}
          </Typography>

          <input
            type='text'
            placeholder={`${selectedOption?.placeholder}`}
            value={senderValue}
            onChange={(e) => {
              onSearch(senderName, e.target.value);
            }}
            className={classes.workflowSearchbarInput}
          />

          <button onClick={handleOptions}>
            {showOptions ? (
              <FiChevronLeft fontSize={20} />
            ) : (
              <FiChevronDown fontSize={20} />
            )}
          </button>
        </Box>

        {showOptions && (
          <Box ref={filterRef} className={classes.workflowSearchOptionsCont}>
            <Typography sx={{ marginBottom: '0.8rem', fontSize: '14px' }}>
              SEARCH USING
            </Typography>
            {filterOptions.map((option: FilterOptionType, index: number) => {
              const { label, placeholder, name } = option;
              return (
                <Box
                  key={index}
                  className={classes.workflowSearchOptionStyle}
                  onClick={() => {
                    setShowOptions(false);
                    onSearch(senderModuleName, name);
                  }}
                >
                  <Typography className={classes.workflowSearchOptionLabel}>
                    {`${label}:`}
                  </Typography>
                  <Typography color={'#8593B5'}>{placeholder}</Typography>
                </Box>
              );
            })}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default SenderSearch;
